(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/jotai/payout-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/jotai/payout-atoms.js');
"use strict";

var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2;

const _jotai = jotai,
  atom = _jotai.atom;
const charityPayouts = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.charityPayouts) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : {};
const atoms = {
  charityPayoutsAtom: atom(charityPayouts),
  charityPayoutChartAtom: atom(null)
};
setGlobal('svs.lyckoplatsen.shared_charity_payout.jotai', {
  atoms
});

 })(window);